import { fadeIn } from '@synoptic/ui-kit/animations.css.js';
import { gray } from '@synoptic/ui-kit/palette.js';
import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const postCardMedia = style([
  {
    display: 'grid',
    gap: space.s16,

    selectors: {
      '&[data-count="1"]': {
        gridTemplate: '1fr / 1fr',
      },
      '&[data-count="2"]': {
        gridTemplate: '1fr / 1fr 1fr',
        alignItems: 'stretch',
        justifyItems: 'stretch',
      },
      '&[data-count="3"],&[data-count="4"]': {
        gridTemplate: '1fr 1fr / 1fr 1fr',
        alignItems: 'stretch',
        justifyItems: 'stretch',
      },
    },
  },
  responsiveStyle({
    mobile: {
      maxHeight: 520,
    },
    tablet: {
      maxHeight: 512,
    },
  }),
]);

export const postCardMediaThumbnail = style([
  {
    all: 'unset',
    display: 'flex',
    borderRadius: borderRadius.r16,
    backgroundColor: gray[300],

    minWidth: 'min(290px, 100%)',
    maxWidth: '100%',
    maxHeight: '100%',

    selectors: {
      [`.${postCardMedia}[data-count="3"] &:first-child`]: {
        gridRow: 'span 2',
      },
    },
  },
  responsiveStyle({
    mobile: {
      minHeight: 64,
    },
    tablet: {
      minHeight: 96,
    },
  }),
]);

export const postCardMediaImg = style({
  minWidth: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: borderRadius.r16,
  outline: 'none',
  cursor: 'zoom-in',
});

export const postCardMediaVideo = style([
  postCardMediaImg,
  {
    objectFit: 'contain',
    cursor: 'default',
    pointerEvents: 'auto',
  },
]);

export const postCardMediaExpandedContainer = style({
  selectors: {
    '&:is(&)': {
      outline: 'none',
      inset: 0,
      maxWidth: 'unset',
      maxHeight: 'unset',
      width: 'unset',
      backgroundColor: 'unset',
      transform: 'unset',
      cursor: 'zoom-out',

      animation: `${fadeIn} 150ms`,
    },
  },
});

export const postCardMediaExpandedHeader = style(
  responsiveStyle({
    mobile: {
      padding: `${space.s32}px ${space.s40}px ${space.s24}px ${space.s24}px`,
      marginRight: space.s20,
    },
    tablet: {
      // padding to prevent user badge from overlapping with absolutely positioned close button
      padding: `0 ${space.s40}px 0 0 `,
      marginRight: 0,
    },
  }),
);

export const postCardMediaExpandedOverlay = style({
  selectors: {
    '&:is(&)': {
      backgroundColor: 'rgba(8, 2, 27, 0.8)',
    },
  },
});

export const postCardMediaExpandedContent = style(
  responsiveStyle({
    mobile: {
      padding: `0 0 94px 0`,
    },
    tablet: {
      padding: `${space.s20}px ${space.s24}px 58px ${space.s24}px`,
    },
  }),
);

export const postCardMediaCarousel = style({
  minHeight: 0,
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
});

export const postCardMediaCarouselButton = style([
  {
    selectors: {
      '&:disabled': {
        visibility: 'hidden',
      },
    },
  },
  responsiveStyle({
    mobile: {
      display: 'none',
    },
    tablet: {
      display: 'flex',
    },
  }),
]);

export const postCardMediaCarouselContentContainer = style({
  height: '100%',
  flexGrow: 1,
});

export const postCardMediaCarouselContent = style({
  height: '100%',
  flexGrow: 1,
});

export const postCardMediaCarouselItem = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const expandedMediaMaxWidth = 1220;
export const expandedMediaMaxHeight = 686;

export const postCardMediaExpandedImg = style({
  width: '100%',
  minHeight: 0,
  objectFit: 'contain',
  maxWidth: expandedMediaMaxWidth,
  maxHeight: expandedMediaMaxHeight,
  cursor: 'zoom-out',
  borderRadius: 0,
});

export const postCardMediaExpandedVideo = style({
  minHeight: 0,
  maxWidth: expandedMediaMaxWidth,
  maxHeight: expandedMediaMaxHeight,
  borderRadius: 0,
});
